import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import TabsComponent from '../../../components/common/Tabs.component';
import TemplateList from '../../templates/List.template';
import logbook from '../../../module/logbook';
import dispatchBoard from '../../../module/dispatchBoard';
import { ColumnCheckboxLogbook } from '../../../module/logbook/conf/List.conf';
import { Box } from '@mui/material';
import DrawerComponent from '../../../components/common/Drawer.component';
import PickupSuppliersDetailsDrawer from '../../../components/dispatchBoard/PickupSuppliersDetailsDrawer.component';
import DownloadRows from '../../../components/table/components/DownloadRows.component';

const TAB_LOGBOOK = 0;
const TAB_DISPATCH_BOARD = 1;

const LogbookTabsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userAuth = useSelector((state) => state?.login?.user);
  const [valueTab, setValueTab] = useState(TAB_LOGBOOK);
  const [openDispatchBoardDrawer, setOpenDispatchBoardDrawer] = useState(false);
  const [selectedDispatchBoardRow, setSelectedDispatchBoardRow] = useState(null);

  const handleDispatchBoardRowClick = (row) => {
    setSelectedDispatchBoardRow(row);
    setOpenDispatchBoardDrawer(true);
  };

  const handleCloseDispatchBoardDrawer = () => {
    setOpenDispatchBoardDrawer(false);
  };

  const moduleLogbook = useMemo(
    () => ({
      ...logbook,
      list: {
        ...logbook?.list,
        noTag: true,
        conf: {
          ...logbook?.list?.conf,
          columns:
            userAuth?.permissions?.[logbook?.tag?.toUpperCase()]?.UPDATE ===
              'true'
              ? _.concat(ColumnCheckboxLogbook, logbook?.list?.conf.columns)
              : logbook?.list?.conf.columns,
        },
      },
      action: {
        conf:
          logbook?.action?.conf?.[userAuth?.department] ||
          logbook?.action?.conf?.DEFAULT,
      },
    }),
    [userAuth]
  );

  const moduleDispatchBoard = useMemo(
    () => ({
      ...dispatchBoard,
      filter: {
        actions: {
          ...dispatchBoard?.filter?.actions,
        },
        conf:
          dispatchBoard?.filter?.conf?.[userAuth?.department] ||
          dispatchBoard?.filter?.conf?.DEFAULT,
      }
    }),
    [userAuth]
  );

  const optionsTabs = useMemo(
    () => [
      {
        id: TAB_LOGBOOK,
        label: 'LOGBOOK',
        children: <TemplateList module={moduleLogbook} />,
      },
      {
        id: TAB_DISPATCH_BOARD,
        label: 'DISPATCH BOARD',
        children:
          <>
            <TemplateList
              module={moduleDispatchBoard}
              onItemClick={handleDispatchBoardRowClick}>
              <DownloadRows module={moduleDispatchBoard} label='Download PDF' />
            </TemplateList>
            <DrawerComponent
              defaultOpen={openDispatchBoardDrawer}
              onClose={handleCloseDispatchBoardDrawer}
              button={<Box sx={{ display: 'none' }} />}
            >
              <PickupSuppliersDetailsDrawer
                row={selectedDispatchBoardRow}
                onClose={handleCloseDispatchBoardDrawer}
              />
            </DrawerComponent>
          </>,
      },
    ],
    [moduleLogbook, moduleDispatchBoard, openDispatchBoardDrawer, selectedDispatchBoardRow]
  );

  const handleTabChange = (tabIndex) => {
    const tabRoutes = ['/logbook', '/dispatch_board'];
    navigate(tabRoutes[tabIndex]);
  };

  const handleChange = (newValue) => {
    setValueTab(newValue);
    handleTabChange(newValue);
  };

  useEffect(() => {
    if (location.pathname === '/dispatch_board') {
      setValueTab(TAB_DISPATCH_BOARD);
      return;
    }

    setValueTab(TAB_LOGBOOK);
  }, [location.pathname]);

  return (
    <TabsComponent
      defaultTab={valueTab}
      onChangeTab={handleChange}
      tabs={optionsTabs}
    />
  );
};

export default LogbookTabsPage;